module.exports = __webpack_public_path__ + "img/profile_pic.8646a06e.jpg";